/* eslint-disable no-unused-vars */
import mergeOptions from 'merge-options';
import { handleActions } from 'redux-actions';
import {
  FIRE_BACKEND_ERROR,
  FIRE_CUSTOMER_INFO_ERROR,
  FIRE_AGENCY_SUB_ID_ERROR,
  FIRE_PAYMENT_ERROR,
  CLEAN_CUSTOMER_ERRORS,
  CLEAN_CUSTOMER_ERROR,
  FIRE_VOUCHER_ERROR,
} from '../constants/ActionTypes';

const initialState = {
  agency: {
    subId: '',
  },
  backEnd: {},
  customerInfo: {},
  payment: {},
  voucher: '',
  termsAndConditions: '',
  finalCleaning: false,
};

const errorsState = handleActions(
  {
    // @todo add rediretor() function to be able to test it.
    FIRE_BACKEND_ERROR: (state, action) => {
      window.location =
        action.payload.redirect === undefined
          ? '/error-unexpected'
          : action.payload.redirect;
    },
    FIRE_CUSTOMER_INFO_ERROR: (state, action) => {
      const newState = mergeOptions({},
        state);
      newState.customerInfo[action.payload.name] = action.payload.value;
      return newState;
    },
    FIRE_AGENCY_SUB_ID_ERROR: (state, action) => {
      const newState = mergeOptions({},
        state);
      newState.agency.subId = action.payload;
      return newState;
    },
    CLEAN_CUSTOMER_ERRORS: (state, action) =>
      mergeOptions({},
        state,
        { customerInfo: {} }),
    CLEAN_CUSTOMER_ERROR: (state, action) => {
      const newState = mergeOptions({},
        state);
      newState.customerInfo[action.payload] = '';
      return newState;
    },
    FIRE_PAYMENT_ERROR: (state, action) => {
      const newState = mergeOptions({},
        state);
      newState.payment[action.payload.name] = action.payload.value;
      return newState;
    },
    FIRE_ABANDON_BASKET_ERROR: (state, action) => {
      const newState = mergeOptions({},
        state);
      newState.abandonBasket = action.payload ? action.payload.message : '';
      return newState;
    },
    FIRE_VOUCHER_ERROR: (state, action) => {
      const newState = mergeOptions({},
        state);
      newState.voucher = action.payload ? action.payload.message : '';
      return newState;
    },
    FIRE_TERMS_AND_CONDITIONS_ERROR: (state, action) => ({
      ...state,
      termsAndConditions: action.payload,
    }),

    FIRE_FINAL_CLEANING_ERROR: (state, action) => ({
      ...state,
      finalCleaning: action.payload,
    }),
  },
  initialState
);

export default errorsState;
